module.exports = __webpack_public_path__ + "static/media/clink.409af90d.wav";